
import {
  computed,
  ref,
  useContext,
  useRouter,
  useStore,
} from '@nuxtjs/composition-api'
import { Pages } from '~/assets/ts/pages'
import { Wishlist } from '~/assets/ts/items/wishlist'
import Loading from '~/components/Loading.vue'
import Breadcrumb from '~/components/Breadcrumb.vue'
import ElementHeadline from '~/components/element/elementHeadline.vue'
import MetaTitle from '~/components/meta/MetaTitle.vue'

declare const window: any

export default {
  components: {
    ElementHeadline,
    Loading,
    Breadcrumb,
    MetaTitle,
  },
  head: {},
  setup() {
    const {
      app: { i18n, router, localePath },
    } = useContext()

    let pageRoute = '' as string | null | undefined
    let pageName = '' as string
    let pageStr = '' as string

    const store = useStore()

    const PagesHelper = new Pages()
    pageRoute = PagesHelper.getPageRoute(router)
    pageName = PagesHelper.getPageName(pageRoute)
    pageStr = PagesHelper.getPageStr(pageName)

    const wishlist = new Wishlist()

    const wishlistItems = ref([] as { slug: string; set: string }[])
    const itemDetails = ref({} as { [key: string]: { slug: string } })
    const wishlistId = ref(wishlist.getCurrentWishlistId() as string)

    if (wishlistId.value !== '') {
      useRouter().push(
        localePath({
          name: 'wishlistDetails',
          params: {
            wishlistHash: wishlistId.value,
          },
        })
      )
    }

    const isLoadingActive = computed(
      () => store.getters['loading/isLoadingActive']
    )

    return {
      i18n,
      pageRoute,
      pageStr,
      wishlistItems,
      itemDetails,
      isLoadingActive,
      wishlistId,
    }
  },
}
